<template>
  <div class="intro">
    <header>Join game as...</header>
    <input
      placeholder="Your name"
      :value="playerNameInput"
      @input="setPlayerNameInput($event.target.value)"
    >
    <button @click="joinGame" :disabled="!playerNameInput" class="button">Join game</button>
    <p class="tip">If you get disconnected, you can always rejoin this game using the same name.</p>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "JoinGame",
  computed: {
    ...mapState(["playerNameInput"])
  },
  methods: {
    ...mapActions(["joinGame"]),
    ...mapMutations(["setPlayerNameInput"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.intro {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
header {
  text-transform: uppercase;
  font-family: "Roboto Condensed";
  font-weight: 300;
  font-size: 15px;
  margin-bottom: 40px;
  color: white;
}
input {
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  height: 60px;
  line-height: 1;
  padding: 0 20px;
  text-align: center;
  color: white;
  background: none;
  width: calc(100% - 100px);
  margin-bottom: 40px;
  font-size: 25px;
  font-family: inherit;
}
input:focus {
  outline: none;
}
</style>
